import { memoizeFunction, mergeStyleSets } from '@fluentui/react';
export var getAppLinkClassNames = memoizeFunction(function (theme) {
    return mergeStyleSets({
        root: {
            color: theme.palette.themeDark,
            selectors: {
                ':visited': {
                    color: theme.palette.themeDark, // shade10
                },
                ':hover': {
                    color: theme.palette.themeDarker, // shade20
                },
                ':active': {
                    color: theme.palette.themeDarkAlt, // shade30
                },
            },
        },
    });
});
//# sourceMappingURL=AppLink.classNames.js.map